import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createTemplate } from "../../../actions/roblox/templatesActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, TemplateInterface } from "../../../store/roblox/templatesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const newParams   = useAppSelector(state => state.roblox.templates.newParams);
  const error       = useAppSelector(state => state.roblox.templates.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: TemplateInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createTemplate(data));

    if (createTemplate.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-template'>
        <h6 className="v-content-label">Create Template</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
